import React, { useEffect, useState } from 'react'
import * as api from '../../requests'
import { Spinner } from '../Loaders/Loaders'
import { Checkbox } from '@tecuity/granite-ui/Checkbox'
import { ContextButton } from '@tecuity/granite-ui/ContextButton'
import { useDispatch } from 'react-redux'
import { setErrorToast, setSuccessToast } from '../../actions'
import { TextInput } from '@tecuity/granite-ui'
import './RequestRecordAccess.scss'

const RequestRecordAccess = (props) => {
  const dispatch = useDispatch()
  const { sourceTypeId, sourceId, uccRecordId } = props
  const [loading, setLoading] = useState(false)
  const [attestations, setAttestations] = useState([])
  const [checkedDeclarations, setCheckedDeclarations] = useState([])
  const [showPasskeyLink, setShowPasskeyLink] = useState(false)
  const [showPasskeyEntry, setShowPasskeyEntry] = useState(false)
  const [passkey, setPasskey] = useState('')
  const [passkeyCreationSuccess, setPasskeyCreationSuccess] = useState('')
  const [passkeyError, setPasskeyError] = useState('')

  useEffect(() => {
    setLoading(true)
    api.GET_APP_SETTING_BY_NAME(
      'RequestAccessAttestations',
      (appSetting) => {
        setLoading(false)
        if (appSetting && appSetting.VALUE) {
          setAttestations(JSON.parse(appSetting.VALUE).slice(0, 2)) // max of 2
        }
      },
      (err) => {
        console.error(err)
        setLoading(false)
        setAttestations([])
      }
    )

    api.DOES_RECORD_HAVE_OWNER(
      sourceTypeId,
      sourceTypeId === 1999 && uccRecordId ? uccRecordId : sourceId,
      (hasOwner) => {
        setShowPasskeyLink(!hasOwner)
      },
      (err) => {
        console.error(err)
        setShowPasskeyLink(false)
      }
    )
  }, [])

  const clickRequestAccess = () => {
    if (sourceTypeId && sourceId) {
      // Determine which path to go down
      setLoading(true)
      if (showPasskeyLink) {
        api.CREATE_REQUEST_ACCESS_PASSKEY(
          {
            SourceTypeId: sourceTypeId,
            SourceId: sourceTypeId === 1999 && uccRecordId ? uccRecordId : sourceId,
            IsPasskeyRequest: true,
          },
          (res) => {
            setPasskeyCreationSuccess(
              `Successfully created Passkey. Please allow 10 - 14 days to receive by mail.`
            )
            dispatch(setSuccessToast('Successfully created Passkey.'))
            setLoading(false)
          },
          (err) => {
            console.error(err)
            dispatch(setErrorToast(err.message || 'Failed to create Passkey. Please contact our office.'))
            setLoading(false)
          }
        )
      } else {
        api.REQUEST_ACCESS_FROM_OWNER(
          {
            SourceTypeId: sourceTypeId,
            SourceId: sourceTypeId === 1999 && uccRecordId ? uccRecordId : sourceId,
            IsPasskeyRequest: false,
          },
          (res) => {
            dispatch(setSuccessToast('Successfully sent request to owner.'))
            setLoading(false)
          },
          (err) => {
            console.error(err)
            dispatch(setErrorToast(err.message || 'Failed to send request to owner. Please contact our office.'))
            setLoading(false)
          }
        )
      }
    } else {
      dispatch(setErrorToast('Missing valid sourceId or sourceTypeId'))
    }
  }

  const clickVerifyPasskey = () => {
    if (!loading) {
      api.VERIFY_REQUEST_ACCESS_PASSKEY(
        {
          SourceTypeId: sourceTypeId,
          SourceId: sourceTypeId === 1999 && uccRecordId ? uccRecordId : sourceId,
          Passkey: passkey,
        },
        (res) => {
          dispatch(setSuccessToast('Successfully verified Passkey.'))
        },
        (err) => {
          console.error(err)
          setPasskeyError(
            'Passkey is invalid or expired. Please try again or request a new Passkey.'
          )
        }
      )
    }
  }

  return (
    <div className="request-access">
      {!showPasskeyEntry && (
        <div className="request-access-content">
          <h4 className="attestation-instructions">
            Please mark all Declarations and click{' '}
            <span style={{ textDecoration: 'underline' }}>Request Access</span> below to request
            access to this record.
          </h4>
          {loading && (
            <div style={{ padding: '12px' }}>
              <Spinner size="small" themeColor="dark-neutral" />
            </div>
          )}
          <div className="attestation-checkbox-wrapper">
            {attestations.map((attestation, i) => {
              return (
                <div key={i}>
                  <Checkbox
                    label={attestation}
                    onClick={(e) => {
                      setCheckedDeclarations((cd) =>
                        e.target.checked ? [...cd, i] : cd.filter((d) => d !== i)
                      )
                    }}
                    checked={checkedDeclarations.includes(i)}
                  />
                </div>
              )
            })}
          </div>
          <ContextButton
            onClick={clickRequestAccess}
            disabled={loading || checkedDeclarations.length < attestations.length}
            variant="primary"
          >
            Request Access
          </ContextButton>
          {passkeyCreationSuccess && (
            <div
              className="error-wrapper"
              onClick={() => {
                setPasskeyCreationSuccess('')
              }}
            >
              <div className="modal-success-message">{passkeyCreationSuccess}</div>
            </div>
          )}
          {showPasskeyLink && (
            <div
              className="dlnTableLink"
              onClick={() => {
                setShowPasskeyEntry(true)
              }}
            >
              I already have a Passkey
            </div>
          )}
        </div>
      )}
      {showPasskeyEntry && (
        <div className="request-access-content">
          <h4>
            Please enter your Passkey below and click{' '}
            <span style={{ textDecoration: 'underline' }}>Verify Passkey</span> to gain access to
            the requested record.
          </h4>
          <TextInput
            label="Passkey"
            value={passkey}
            onChange={(e) => {
              setPasskey(e.target.value)
              setPasskeyError('')
            }}
          />
          <ContextButton
            onClick={clickVerifyPasskey}
            disabled={loading || !passkey}
            variant="primary"
          >
            Verify Passkey
          </ContextButton>
          {passkeyError && (
            <div className="error-wrapper">
              <div className="modal-error-message">{passkeyError}</div>
            </div>
          )}
          <div
            className="dlnTableLink"
            onClick={() => {
              setShowPasskeyEntry(false)
              setPasskey('')
            }}
          >
            Request Access Again
          </div>
        </div>
      )}
    </div>
  )
}

export default RequestRecordAccess
